import { BreadCrumb } from "@kunduz/ui";
import React, { ReactElement } from "react";
import { type IWordpress } from "../interfaces";
import { HomeLine } from "@untitled-ui/icons-react";

export const BlogBreadcrumb = (props: Props): ReactElement => {
  const sorted: {
    name: string;
    slug: string;
    parentId?: string;
    id: string;
  }[] = sortCategories();

  function sortCategories() {
    if (!props.post?.categories.nodes) return [];
    const list = props.post.categories.nodes;
    const result: any[] = [];
    const parent = list.find((c) => !c.parentId);
    if (!parent) return [];

    result.push(parent);

    for (let i = 0; i < list.length; i++) {
      //find next item with last items id
      const last: any = result[result.length - 1];
      const next: any = list.find((c) => c.parentId == last.id);
      next && result.push(next);
    }

    return result;
  }

  function prepareBase() {
    return {
      label: "Anasayfa",
      icon: <HomeLine />,
      url: `${props.lang === "tr" ? "/tr" : ""}/`,
    };
  }

  function prepareBreadcrumbItems(): {
    label: string;
    url: string;
    onClick?: () => void;
  }[] {
    const items: any[] = sorted.map((c) => {
      return {
        label: c.name,
        url: `${props.lang === "tr" ? "/tr" : ""}/blog/category/${c.slug}/`,
      };
    });

    items.unshift({
      label: "Blog",
      url: `${props.lang === "tr" ? "/tr" : ""}/blog/`,
    });

    if (props.post) {
      items.push({
        label: props.post.title,
        url: null,
      });
    } else if (props.category) {
      items.push({
        label: props.category.seo.title,
        url: null,
      });
    }
    return items;
  }

  return (
    <BreadCrumb
      base={prepareBase()}
      items={prepareBreadcrumbItems()}
      linkAs={props.linkAs}
    />
  );
};

interface Props {
  post?: IWordpress.IWordpressPost;
  category?: IWordpress.IWordpressCategoryPostResponse["category"];
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
